import React from 'react'
import { useState } from 'react'
import { uploadFileAPI } from '../../../api/file/fileAPI'
import { responseError } from '../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../UI/messages/ErrorMessage'
import MySpiner from '../../UI/spiner/MySpiner'
import MyButton from '../../UI/form/MyButton'
import SuccessMessage from '../../UI/messages/SuccessMessage'

const FileUploadSave = ({ files, tableOwnerId, tableOwnerType, type, setOpen }) => {

    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')
    const [isAdded, setIsAdded] = useState(false)
    const [loading, setLoading] = useState(false)

    const save = () => {
        setSuccess('')
        setError('')
        setLoading(true)
        const data = getDataForBd()

        uploadFileAPI(data).then(data => {
            setSuccess('Файли успішно додано')
            setIsAdded(true)
            setLoading(false)
        }).catch(e => {
            const error = responseError(e)
            setError(error)
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const formData = new FormData()

        // додаємо файли
        files.forEach((file) => {
            formData.append('files', file) // або 'file' якщо бекенд чекає один ключ
        })

        formData.append('type', type)
        formData.append('tableOwnerId', tableOwnerId)
        formData.append('tableOwnerType', tableOwnerType)

        return formData
    }

  return (
    <div>
        <ErrorMessage error={error} />
        <SuccessMessage success={success} />
        {
            loading ? <MySpiner /> : ''
        }
        {
            files && files.length > 0 ?
                <MyButton
                    onClick={save}
                    disabled={loading || isAdded ? true : false}
                >
                    Зберегти
                </MyButton>
            : ''
        }
    </div>
  )
}

export default FileUploadSave